export default "__VITE_ASSET__E6U4YVOd__"